import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { authAPI } from '../../api'
import { authData } from '../data/slice'
import { AUTH_LOGOUT_FAILED, AUTH_LOGOUT_REQUEST, AUTH_LOGOUT_SUCCESS } from './actionTypes'

export const authLogoutPA = createPromiseAction(
  AUTH_LOGOUT_REQUEST,
  AUTH_LOGOUT_SUCCESS,
  AUTH_LOGOUT_FAILED
)()

function* logout(action) {
  try {
    const response = yield call(authAPI.logOut)
    const { data } = response

    yield put(authLogoutPA.success({}))

    yield put(authData.cleanData())

    resolvePromiseAction(action, {})
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* logoutSaga() {
  yield takeEvery(authLogoutPA.request, logout)
}
